<template>
  <div class="avatar" @click="uploadImg">
    <img v-if="url" :src="url" alt="">
    <svg v-else t="1674035025884" class="icon" viewBox="0 0 1036 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3628" width="200" height="200"><path d="M231.634 295.165c0-153.595 124.94-278.536 278.537-278.536 153.596 0 278.536 124.94 278.536 278.536 0 153.605-124.94 278.53-278.536 278.53-153.597 0-278.537-124.925-278.537-278.53zM0 1014.09C5.997 946.74 38.33 708.09 286.847 580.277c61.637 48.383 139.07 77.515 223.325 77.515 84.716 0 162.568-29.428 224.37-78.306 249.591 127.274 279.721 364.251 285.8 434.597-1.482 1.434-1018.869 0.118-1020.342 0.007z m0 0" p-id="3629" fill="#bfbfbf"></path></svg>
  </div>
</template>

<script>
export default {
  name: "Avatar",
  props: {
    src: String,
  },
  data() {
    return {
      url: this.src,
    }
  },
  methods: {
    uploadImg(){
      const input = document.createElement('input');
      input.type = "file";
      input.accept = "image/png, image/jpeg, image/gif, image/jpg";
      input.onchange = e => {
        const file = e.target.files[0];
        const url = window.URL.createObjectURL(file);
        this.url = url;
        this.$emit('change', file);
      }
      input.click();
    }
  },
}
</script>

<style lang="less" scoped>
.avatar{
  width: 80px;
  height: 80px;
  img,svg{
    width: 100%;
    height: 100%;
  }
}
</style>